import { Card } from 'antd'
import React from 'react'
import styles from "./GetCardLayout.module.scss"

const GetCardLayout = ({children, ...props}) => {
  return (
    <Card className={styles.cardWrapper} {...props}>
        {children}
    </Card>
  )
}

export default GetCardLayout